import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Edit02 = function Edit02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m18 10-4-4M2.5 21.5l3.3843-.376c.4135-.046.6203-.069.8135-.1315a2 2 0 0 0 .485-.2331c.1696-.1119.3167-.2589.6109-.5531L21 7c1.1046-1.1046 1.1046-2.8954 0-4s-2.8954-1.1046-4 0L3.7937 16.2063c-.2942.2942-.4413.4412-.553.6108a2 2 0 0 0-.2332.4851c-.0626.1932-.0856.3999-.1315.8134z"
    })
  }));
};
export default Edit02;